import UnityLogo from "../img/Icons/unityIcon.png";
import BlenderLogo from "../img/Icons/blenderIcon.png";
import ReactLogo from "../img/Icons/Logos/ReactLogo.png";
import HtmlLogo from "../img/Icons/Logos/HTML5Logo.png";
import CssLogo from "../img/Icons/Logos/CssLogo.png";
import CSharpLogo from "../img/Icons/Logos/CsharpLogo.png";
import ItchIcon from "../img/Icons/ItchIcon.png";
import { projectsWithItchBadges } from "../data/itchPages";

const technologyLogos = {
  Unity: UnityLogo,
  Blender: BlenderLogo,
  React: ReactLogo,
  HTML: HtmlLogo,
  CSS: CssLogo,
  "C#": CSharpLogo,
  "C-Sharp": CSharpLogo,
};

export default function ProjectTile({ projectId, title, description, link, imageSrc, technologies = [] }) {
  const supportedTechnologies = technologies
    .map((technology) => ({ name: technology, logo: technologyLogos[technology] }))
    .filter((technology) => technology.logo);

  const updatePointerPosition = (pointerEvent) => {
    if (pointerEvent.pointerType === "touch") return;

    const tileBounds = pointerEvent.currentTarget.getBoundingClientRect();
    const horizontalPosition = (pointerEvent.clientX - tileBounds.left) / tileBounds.width;
    const verticalPosition = (pointerEvent.clientY - tileBounds.top) / tileBounds.height;
    const tiltX = (0.5 - verticalPosition) * 8;
    const tiltY = (horizontalPosition - 0.5) * 8;

    pointerEvent.currentTarget.style.setProperty("--tilt-x", `${tiltX}deg`);
    pointerEvent.currentTarget.style.setProperty("--tilt-y", `${tiltY}deg`);
  };

  const resetPointerPosition = (pointerEvent) => {
    pointerEvent.currentTarget.style.setProperty("--tilt-x", "0deg");
    pointerEvent.currentTarget.style.setProperty("--tilt-y", "0deg");
  };

  const technologyNames = supportedTechnologies.map(({ name }) => name).join(", ");

  return (
    <a
      className="projectTileLink"
      href={link}
      aria-label={`${title}. Technologies: ${technologyNames || "not specified"}`}
      onPointerMove={updatePointerPosition}
      onPointerLeave={resetPointerPosition}
      onBlur={resetPointerPosition}
    >
      <div className="projectImg">
        <img className="projectCover" src={imageSrc} alt="" />
        {projectsWithItchBadges.includes(projectId) && (
          <span className="itchBadge" aria-label="Available on itch.io" title="Available on itch.io">
            <img src={ItchIcon} alt="" />
          </span>
        )}
        <div className="content">
          <h2>{title}</h2>
          <p>{description}</p>
          {supportedTechnologies.length > 0 && (
            <div className="projectTechnologyIcons" aria-label={`Technologies: ${technologyNames}`}>
              {supportedTechnologies.map(({ name, logo }) => (
                <img key={name} src={logo} alt={name} title={name} />
              ))}
            </div>
          )}
        </div>
      </div>
    </a>
  );
}
